module.exports = __webpack_public_path__ + "static/media/lesnymech.d064b5aa.jpg";